import PropTypes from "prop-types"
import { CONTENT_SET_METADATA } from "resources/content-sets"
import { MODEL_METADATA_SHAPE, INSTRUMENT_COLUMNS, INSTRUMENTS_WITH_METADATA_SHAPE } from "connected-components/asset-view/prop-types"

export const BETA_INSTRUMENT_SHAPE = PropTypes.shape({
  securityId: PropTypes.shape({
    internalId: PropTypes.string,
  }),
  resource: PropTypes.shape({
    alias: PropTypes.string,
    type: PropTypes.string,
  }),
  benchmarkId: PropTypes.string,
  indexId: PropTypes.string,
})

export const BETA_FIELDS_SHAPE = PropTypes.arrayOf(PropTypes.string)

export const DRIFT_DATES_SHAPE = PropTypes.shape({
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
})

export const FACTORS_VIEW_COMMON_PROPS = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  instrumentsWithMetadata: INSTRUMENTS_WITH_METADATA_SHAPE.isRequired,
  instrumentColumns: INSTRUMENT_COLUMNS.isRequired,
  adjustedRiskStartDate: PropTypes.string,
  driftDates: DRIFT_DATES_SHAPE,
  selectedContentSetMetadata: CONTENT_SET_METADATA.isRequired,
}
